import TermsAndConditions from './TermsAndConditions'
import Privacy from './Privacy'
import TreatmentPlanTermsOfService from "./TreatmentPlanTermsOfService";
import ChronicConditionsModal from 'xAppLib/UIelems/ChronicConditionsModal';
import MedicalHistoryModal from 'xAppLib/UIelems/MedicalHistoryModal';
import MinorComplicationModal from 'xAppLib/UIelems/MinorComplicationModal';
import PrescriptionsUpdate from './PrescriptionsUpdate';
import HeidiConsent from './HeidiConsent';
import CmgTypeform from './CmgTypeform';
import OnePassLinked from './OnePassLinked';
import OnePassDetails from './OnePassDetails';
import MedConsultInfo from './MedConsultInfo';
import { Socials } from '../../xAppLib/UIelems/ShareToSocialsButton';
import AdminContactUser from '../../xAppLib/Users/AdminContactUser';
import { PharmacyProfile } from '@iscr/xAppLib/Users/AdminUsers/PharmacyProfile';
import { WEIGHT_LOSS_TOS_PN, WeightLossTermsOfService } from "@iscr/views/ordering/components/weightLossTOSForm";
import { WEIGHT_LOSS_YOUFOODZ_TOS_PN, WeightLossYoufoodzTermsOfService } from "@iscr/views/ordering/components/weightLossYoufoodzTOS";
import { MedCertModal } from './MedCertModal';

const Content = ({ name, target="iscr", ...props }) => {
	let c = "NOT FOUND"
	switch(name){

		case 'privacy-policy':
			c = <Privacy />
			break;
		case 'treatment-plan-tos':
			c = <TreatmentPlanTermsOfService embedded />
			break;
		case WEIGHT_LOSS_TOS_PN:
			c = <WeightLossTermsOfService />
			break;
		case WEIGHT_LOSS_YOUFOODZ_TOS_PN:
			c = <WeightLossYoufoodzTermsOfService />
			break;
		case 'terms-and-conditions':
			c = <TermsAndConditions type={target}/>
			break;
		case 'customer-terms-and-conditions':
			c = <TermsAndConditions type="customer" {...props}/>
			break;
		case 'loyalty-program-terms-and-conditions':
			c = <TermsAndConditions type="loyalty-program" {...props}/>
			break;
		case 'platform-terms-and-conditions':
			c = <TermsAndConditions type="platform" {...props}/>
			break;
		case 'healthcredit-terms-and-conditions':
			c = <TermsAndConditions type="healthcredit"/>
			break;
		// case 'ileg-eula':
		// 	c = <IlegEula />
		// 	break;
		case 'chro-cond':
			c = <ChronicConditionsModal {...props} />
			break;
		case 'medical-history':
			c = <MedicalHistoryModal {...props} />
			break;
		case 'medical-history-and-chro-cond':
			c = <MedicalHistoryModal navigateToChroCond {...props} />
			break;
		case 'prescriptions-update':
			c = <PrescriptionsUpdate />
			break;
		case 'cmg-typeform':
			c = <CmgTypeform />
			break;
        case 'onepass-linked':
            c = <OnePassLinked {...props} />
            break;
		case 'onepass-details':
			c = <OnePassDetails {...props} />
			break;
		case 'admin-contact-user':
			c = <AdminContactUser {...props} />
			break;
		case 'pharmacy-profile':
			c = <PharmacyProfile {...props} />
			break;
		case 'minor-complication':
			c = <MinorComplicationModal {...props} />
			break;
		case 'med-consult':
			c = <MedConsultInfo {...props} />
			break;
		case 'socials':
			c = <Socials {...props} />
			break;
		case 'promo-terms-and-conditions':
			c = <TermsAndConditions type="promo" {...props} />
			break;
		case 'heidi-consent':
			c = <HeidiConsent />
			break;
		case 'med-cert-preview':
		case 'med-cert-employers':
			c = <MedCertModal {...props}/>
			break;
		default:
			props.txt && (c = props.txt)
	}
	return c
}
	

export default Content
